import React from 'react';
import type { SelectionBounds } from '../../utils/workspace.types';

interface SelectionRectangleProps {
  isVisible: boolean;
  start: SelectionBounds | null;
  end: SelectionBounds | null;
}

/**
 * Selection Rectangle component - visual feedback for drag selection
 * Extracted from STAADWorkspace3D to maintain exact behavior
 */
export const SelectionRectangle: React.FC<SelectionRectangleProps> = ({
  isVisible,
  start,
  end
}) => {
  if (!isVisible || !start || !end) return null;

  const minX = Math.min(start.x, end.x);
  const maxX = Math.max(start.x, end.x);
  const minY = Math.min(start.y, end.y);
  const maxY = Math.max(start.y, end.y);

  const width = maxX - minX;
  const height = maxY - minY;

  return (
    <div
      style={{
        position: 'absolute',
        left: minX,
        top: minY,
        width: width,
        height: height,
        border: '2px dashed #2196F3',
        backgroundColor: 'rgba(33, 150, 243, 0.1)',
        pointerEvents: 'none',
        zIndex: 1000
      }}
    />
  );
};
